import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import GifLoder from "./GifLoder";

const ProtectedRoute = ({ element: Component }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <GifLoder />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
